const NewsController = () => import('./Controller')
const SortNews = () => import('./SortNews')

export default function installComponents(Vue) {
  Vue.component('NewsController', NewsController)
  Vue.component('SortNews', SortNews)
}
